export default __webpack_public_path__ + "static/media/signup_1.bfc0ca73.jpg";